export default {
	text: {
		fontFamily: 'Work Sans',
		fontWeight: 'bold',
	},
};
